export const GET_ALERTS = 'GET_ALERTS'
